import { biddingStrategyType } from './bidding-strategy-type';

function getAdGroupItems({ i18n, changeBiddingStrategy }) {
  const entityName = 'AdGroup';

  const result = [
    {
      text: i18n.getString('BidStrategy_Option_ParentCampaign'),
      classes: ['bulk-edit-bid-strategy-inherit-parent'],
      onClick: changeBiddingStrategy(biddingStrategyType.parent, entityName),
    }, {
      text: i18n.getString('BidStrategy_Option_Manual'),
      classes: ['bulk-edit-bid-strategy-manual'],
      onClick: changeBiddingStrategy(biddingStrategyType.manual, entityName),
    },
  ];

  return result;
}

function getKeywordItems({ i18n, changeBiddingStrategy }) {
  const entityName = 'Keyword';

  const result = [
    {
      text: i18n.getString('BidStrategy_Option_ParentAdGroup'),
      classes: ['bulk-edit-bid-strategy-inherit-parent'],
      onClick: changeBiddingStrategy(biddingStrategyType.parent, entityName),
    }, {
      text: i18n.getString('BidStrategy_Option_Manual'),
      classes: ['bulk-edit-bid-strategy-manual'],
      onClick: changeBiddingStrategy(biddingStrategyType.manual, entityName),
    },
  ];

  return result;
}

function getCampaignItems({
  permissions, i18n, changeBiddingStrategy,
}) {
  const entityName = 'Campaign';

  const result = permissions.IsManualBiddingDeprecationEnabled ?
    [
      {
        text: i18n.getString('BidStrategy_Option_EnhancedCPC'),
        classes: ['bulk-edit-bid-strategy-enhanced-cpc'],
        onClick: changeBiddingStrategy(biddingStrategyType.enhancedCPC, entityName),
      },
    ] :
    [
      {
        text: i18n.getString('BidStrategy_Option_Manual_Campaign'),
        classes: ['bulk-edit-bid-strategy-manual'],
        onClick: changeBiddingStrategy(biddingStrategyType.manual, entityName),
      }, {
        text: i18n.getString('BidStrategy_Option_EnhancedCPC'),
        classes: ['bulk-edit-bid-strategy-enhanced-cpc'],
        onClick: changeBiddingStrategy(biddingStrategyType.enhancedCPC, entityName),
      },
    ];

  result.push({
    text: i18n.getString('BidStrategy_Option_MaximizeClicks'),
    classes: ['bulk-edit-bid-strategy-maximize-clicks'],
    onClick: changeBiddingStrategy(biddingStrategyType.maximizeClicks, entityName),
  });

  result.push({
    text: i18n.getString('BidStrategy_Option_MaximizeConversions'),
    classes: ['bulk-edit-bid-strategy-maximize-conversioins'],
    onClick: changeBiddingStrategy(biddingStrategyType.maximizeConversions, entityName),
  });

  result.push({
    text: i18n.getString('BidStrategy_Option_TargetCPA'),
    classes: ['bulk-edit-bid-strategy-target-cpa'],
    onClick: changeBiddingStrategy(biddingStrategyType.targetCpa, entityName),
  });

  // should remove old pilot after new pilot enabled
  if (permissions.IsCampaignTargetROASBidStrategyEnabled || permissions.IsNewCampaignTargetROASBidStrategyEnabled) { // eslint-disable-line
    result.push({
      text: i18n.getString('BidStrategy_Option_TargetROAS'),
      classes: ['bulk-edit-bid-strategy-target-roas'],
      onClick: changeBiddingStrategy(biddingStrategyType.targetRoas, entityName),
    });
  }

  if (permissions.IsMaximizeConversionValueEnabled) {
    result.push({
      text: i18n.getString('BidStrategy_Option_MaxConversionValue'),
      classes: ['bulk-edit-bid-strategy-maximize-conversion-value'],
      onClick: changeBiddingStrategy(biddingStrategyType.maxConversionValue, entityName),
    });
  }

  if (permissions.IsTargetImpressionShareEnabled) {
    result.push({
      text: i18n.getString('BidStrategy_Option_TargetImpressionShare'),
      classes: ['bulk-edit-bid-strategy-target-impression-share'],
      onClick: changeBiddingStrategy(biddingStrategyType.targetImpressionShare, entityName),
    });
  }

  return result;
}

export function getMenuItems({
  permissions, i18n, entityName, changeBiddingStrategy,
}) {
  switch (entityName) {
    case 'Campaign':
      return getCampaignItems({
        permissions, i18n, changeBiddingStrategy,
      });
    case 'AdGroup':
      return getAdGroupItems({ i18n, changeBiddingStrategy });
    case 'Keyword':
      return getKeywordItems({ i18n, changeBiddingStrategy });
    default:
      throw new Error('Entity type bid strategy menu not defined');
  }
}
